import {Pps} from "./pps";

export class SpsXPps {
	static pps_TYPE;

	pps: Pps[];

	get firstPps() {
		let prop = 'pps';
		if (!this[prop] || !this[prop][0]) {
			this[prop] = [{}];
		}
		return this[prop][0];
	}

	// public initPpsFromRequestedProcedure(requestedProcedureItem: RequestedProcedure[]){
	// 	//Remove the exists pps items.
	// 	this.pps.splice(0,this.pps.length);
	//
	// 	if (requestedProcedureItem){
	// 		requestedProcedureItem.forEach((procedure:RequestedProcedure) => {
	// 			procedure.firstSps.spsItem.forEach((currItem:SpsItem) => {
	// 				this.addPPS(procedure.firstSps.FKLookupRows.spsCodeKey,  currItem.FKLookupRows.procedureCodeKey);
	// 			});
	// 		});
	// 	}
	// }
	//
	// public addPPS(spsCode: ISPSCode, procedureCode: IProcedureCode) {
	// 	let currPps: Pps;
	// 	if (this.pps) {
	// 		//Check if sps array contain the ppsKey.
	// 		currPps = this.pps.find((pps) => {
	// 			return pps.ppsCodeKey === spsCode.SPSCodeKey;
	// 		});
	// 	} else {
	// 		this.pps = [];
	// 	}
	//
	// 	if (currPps) {
	// 		//Try to add the procedure to the pps item level (if the procedure not exists).
	// 		currPps.addPpsItem(procedureCode);
	// 	} else {
	// 		//Add a new pps.
	// 		let createPps = new Pps();
	// 		createPps.SetData(spsCode, procedureCode);
	// 		this.pps.push(createPps);
	// 	}
	// }

}
SpsXPps.pps_TYPE = Pps;
